<template>
  <div>
    <div class="d-flex align-items-center mb-3 p-0">
      <div class="d-flex align-items-center">
        <span class="sectionTitle">اطلاعات کاربر</span>
      </div>
      <div class="line"></div>
    </div>
    <div class="section">
      <div class="mb-3">
        <BaseText
          :showError="nameError"
          :required="true"
          errortext="وارد کردن نام الزامی است"
          :value="addFactorData.firstName"
          @input="addFactorData.firstName = $event"
          title="نام"
          placeholder="نام"
        />
      </div>
      <div class="mb-3">
        <BaseText
          :showError="lastNameError"
          :required="true"
          errortext="وارد کردن نام خانوادگی الزامی است"
          :value="addFactorData.lastName"
          @input="addFactorData.lastName = $event"
          title="نام خانوادگی"
          placeholder="نام خانوادگی"
        />
      </div>
      <div class="mb-3">
        <BaseText
          :showError="phoneError || phoneResponseErr"
          :required="true"
          :errortext="phoneError ? 'وارد کردن تلفن همراه الزامی است' : phoneResponseText"
          :value="addFactorData.mobile"
          :maxlength="11"
          @input="addFactorData.mobile = $event"
          inputType="number"
          title="تلفن همراه"
          placeholder="تلفن همراه"
        />
      </div>
      <div class="mb-3">
        <BaseText :value="addFactorData.telephone" :maxlength="11" @input="addFactorData.telephone = $event" inputType="number" title="تلفن ثابت" placeholder="تلفن ثابت" />
      </div>
      <div class="mb-3">
        <BaseText :value="addFactorData.nationalCode" :maxlength="10" @input="addFactorData.nationalCode = $event" inputType="number" title="کد ملی" placeholder="کد ملی" />
      </div>
      <div>
        <BaseText :value="addFactorData.email" @input="addFactorData.email = $event" inputType="email" title="ایمیل" placeholder="ایمیل" />
      </div>
    </div>
    <div class="d-flex align-items-center mb-3 p-0">
      <div class="d-flex align-items-center">
        <span class="sectionTitle">اطلاعات پستی</span>
      </div>
      <div class="line"></div>
    </div>
    <div class="section">
      <b-row class="mb-3">
        <b-col>
          <div v-if="forceUpdateFlag">
            <ComboBox
              title="استان"
              placeholder="استان"
              @selectedItem="selectedProvince($event)"
              @searchedItem="searchedProvince($event)"
              :searchedData="searchedProvinceData"
              @input="selectProvince = $event"
              :selectedValue="selectProvince"
            />
          </div>
        </b-col>
        <b-col>
          <div v-if="resetCityFlag">
            <ComboBox
              title="شهر"
              placeholder="شهر"
              @selectedItem="selectedCity($event)"
              @searchedItem="searchedCity($event)"
              :searchedData="searchedCityData"
              @input="selectCity = $event"
              :selectedValue="selectCity"
            />
          </div>
        </b-col>
      </b-row>
      <div class="mb-3">
        <TextAreaInput :value="addFactorData.address.addressText" @input="addFactorData.address.addressText = $event" title="آدرس" placeholder="آدرس" />
      </div>
      <div>
        <BaseText
          :value="addFactorData.address.postalCode"
          :maxlength="10"
          @input="addFactorData.address.postalCode = $event"
          inputType="number"
          title="کد پستی"
          placeholder="کد پستی"
        />
        <!-- type balaie number shavad -->
      </div>
      <div></div>
    </div>
    <div class="d-flex align-items-center mb-3 p-0">
      <div class="d-flex align-items-center">
        <span class="sectionTitle">یادداشت</span>
      </div>
      <div class="line"></div>
    </div>
    <div class="section">
      <div>
        <TextAreaInput :value="addFactorData.adminNote" @input="addFactorData.adminNote = $event" title="یادداشت" placeholder="یادداشت" />
      </div>
    </div>
    <b-row class="mb-3">
      <b-col class="deactiveUser" lg="4">
        <b-form-checkbox id="checkbox-1" v-model="deactiveUserStatus" @change="deactiveUser" name="checkbox-1"> غیرفعال کردن کاربر </b-form-checkbox>
      </b-col>
      <b-col lg="8">
        <div class="buttonClass">
          <div @click="addFactor">
            <Button :loading="submitLoading" text="ثبت" btnClass="aprove btn-border" />
          </div>
          <b-button @click="openRemoveModal" class="deleteButton">
            <span class="deleteTitle">حذف کاربر</span>
            <i class="far fa-times-circle deleteTitle"></i>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-modal ref="deleteUser" no-close-on-esc hide-footer headerClass="p-3 border-bottom-0" centered header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title">آیا از حذف کاربر اطمینان دارید؟</div>
        <div class="buttons">
          <div @click="closeRemoveModal">
            <button class="cancelButton">خیر</button>
          </div>
          <div>
            <button @click="deleteUserFunction" class="approveButton">بلی</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseText from '../common/form/formModules/BaseText.vue'
import ComboBox from '../common/form/formModules/ComboBox.vue'
import TextAreaInput from '../common/form/formModules/TextAreaInput.vue'
import { invoiceMixins } from '../../utils/mixins'
import Button from '../common/Button.vue'
import invoiceDataProvider from '../../services/invoice'
import userDataProvider from '../../services/user'
export default {
  name: 'user-information-form',
  mixins: [invoiceMixins],
  components: {
    BaseText,
    ComboBox,
    TextAreaInput,
    Button,
  },
  data() {
    return {
      selectProvince: '',
      selectCity: '',
      phoneResponseText: '',
      phoneError: false,
      phoneResponseErr: false,
      lastNameError: false,
      nameError: false,
      resetCityFlag: true,
      submitLoading: false,
      allowSubmit: true,
      forceUpdateFlag: true,
      deactiveUserStatus: false,
      searchedProvinceData: [],
      searchedCityData: [],
      addFactorData: {
        firstName: '',
        lastName: '',
        nationalCode: '',
        mobile: '',
        email: '',
        telephone: '',
        adminNote: '',
        address: {
          cityId: '',
          addressText: '',
          postalCode: '',
        },
      },
    }
  },
  beforeMount() {
    this.forceUpdateFlag = false
    this.$nextTick(() => {
      invoiceDataProvider
        .getProvince({
          pageSize: 1000,
          pageNumber: 1,
          keyword: '',
        })
        .then((res) => {
          this.$store.dispatch('invoice/setProvinceData', res.data.data)
          this.searchedProvinceData = this.provinceData
        })
      this.forceUpdateFlag = true
    })
    userDataProvider
      .getUserDetails({
        peopleId: this.$route.params.id,
      })
      .then((res) => {
        const peopleData = res.data.data.peopleGlobalDto
        this.addFactorData.firstName = peopleData.firstName
        this.addFactorData.lastName = peopleData.lastName
        this.addFactorData.mobile = peopleData.mobile
        this.addFactorData.email = peopleData.email
        this.addFactorData.telephone = peopleData.telephone
        this.addFactorData.adminNote = peopleData.adminNote
        this.addFactorData.address.addressText = peopleData.address.addressText
        this.addFactorData.address.cityId = peopleData.address.cityId
        this.addFactorData.address.postalCode = peopleData.address.postalCode
        this.addFactorData.nationalCode = peopleData.nationalCode
        this.deactiveUserStatus = peopleData.isDeactivate
        invoiceDataProvider
          .getProvince({
            pageSize: 1000,
            pageNumber: 1,
            keyword: '',
          })
          .then((res) => {
            this.$store.dispatch('invoice/setProvinceData', res.data.data)
            this.searchedProvinceData = this.provinceData
            this.selectProvince = res.data.data.find((province) => province.key == peopleData.address.provinceId).value
          })
        invoiceDataProvider
          .getCity({
            pageSize: 1000,
            pageNumber: 1,
            keyword: '',
            ProvinceId: peopleData.address.provinceId,
          })
          .then((res) => {
            this.selectCity = res.data.data.find((city) => city.key == peopleData.address.cityId).value
          })
      })
  },

  methods: {
    addFactor() {
      this.phoneError = false
      this.lastNameError = false
      this.nameError = false
      this.$emit('goUp', false)
      if (!this.addFactorData.firstName) {
        this.$emit('goUp', true)
        this.nameError = true
      }
      if (!this.addFactorData.lastName) {
        this.$emit('goUp', true)
        this.lastNameError = true
      }
      if (!this.addFactorData.mobile) {
        this.$emit('goUp', true)
        this.phoneError = true
        return
      } else {
        if (this.allowSubmit && this.addFactorData.firstName && this.addFactorData.lastName && this.addFactorData.mobile) {
          this.submitLoading = true
          this.allowSubmit = false
          invoiceDataProvider
            .updatePeople({
              id: this.$route.params.id,
              firstName: this.addFactorData.firstName,
              lastName: this.addFactorData.lastName,
              mobile: this.addFactorData.mobile,
              email: this.addFactorData.email,
              telephone: this.addFactorData.telephone,
              adminNote: this.addFactorData.adminNote,
              nationalCode: this.addFactorData.nationalCode,
              address: {
                cityId: this.addFactorData.address.cityId,
                addressText: this.addFactorData.address.addressText,
                postalCode: this.addFactorData.address.postalCode,
              },
            })
            .then((res) => {
              this.submitLoading = false
              this.phoneResponseErr = false
              this.allowSubmit = true
              this.$emit('userUpdated', true)
            })
            .catch((err) => {
              if (err.response.status == 409) {
                this.$emit('goUp', true)
                this.phoneResponseErr = true
                this.submitLoading = false
                this.allowSubmit = true
                this.phoneResponseText = err.response.data.message
              }
            })
        }
      }
    },
    deleteUserFunction() {
      invoiceDataProvider
        .deletePeople({
          peopleId: this.$route.params.id,
        })
        .then((res) => {
          setTimeout(() => {
            this.$router.push({ path: '/list/user' })
          }, 100)
        })
    },
    deactiveUser() {
      this.deactiveUserStatus == !this.deactiveUserStatus
      setTimeout(() => {
        invoiceDataProvider.deactivePeople({
          peopleId: this.$route.params.id,
          deactiveState: this.deactiveUserStatus,
        })
      }, 100)
    },
    openRemoveModal() {
      this.$refs['deleteUser'].show()
    },
    closeRemoveModal() {
      this.$refs['deleteUser'].hide()
    },
    selectedProvince(event) {
      this.resetCityFlag = false
      this.$nextTick(() => {
        this.resetCityFlag = true
      })
      invoiceDataProvider
        .getCity({
          pageSize: 1000,
          pageNumber: 1,
          keyword: '',
          ProvinceId: event.key,
        })
        .then((res) => {
          this.$store.dispatch('invoice/setCityData', res.data.data)
          this.searchedCityData = this.cityData
        })
    },
    searchedProvince(event) {
      this.searchedProvinceData = this.provinceData
      this.searchedProvinceData = this.provinceData.filter((item) => {
        return item.value.includes(event)
      })
    },
    selectedCity(event) {
      this.addFactorData.address.cityId = event.key
    },
    searchedCity(event) {
      this.searchedCityData = this.cityData
      this.searchedCityData = this.cityData.filter((item) => {
        return item.value.includes(event)
      })
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .custom-control-label {
  margin-right: 5px;
}
::v-deep .custom-checkbox .custom-control-input {
  border-radius: 4px;
}
::v-deep .custom-checkbox .custom-control-input:checked {
  opacity: 0.5;
}
::v-deep .custom-checkbox .custom-control-input:checked + .custom-control-label {
  opacity: 0.5;
}
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.deleteButton {
  padding: 6px 5px 6px 10px;
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #ffffff;
  border: 1px solid #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.deleteTitle {
  color: gray;
  margin-right: 5px;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
.btn-border {
  border-radius: 4px !important;
}
.aprove {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.invoice-disable {
  color: rgba(73, 80, 87, 0.4) !important;
  span {
    color: rgba(73, 80, 87, 0.4) !important;
  }
}
.__item {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
}
.section {
  padding: 26px 30px;
  margin-bottom: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}
.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
.btn-border {
  border-radius: 4px !important;
}
.aprove {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.deactiveUser {
  display: flex;
  align-items: center !important;
  padding-right: 0;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.submitButton {
  font-size: 14px;
  padding: 8px 45px;
  color: white;
  background: #556ee6;
  border: 1px solid #556ee6;
  box-sizing: border-box;
  border-radius: 4px;
}
.cancleButton {
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.deleteTitle {
  color: gray;
  margin-right: 5px;
}
.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px;
    color: white;
    background: #556ee6;
    border-radius: 4px;
  }
  .cancelButton {
    padding: 6px 90px !important;
    margin-left: 12px !important;
    color: white !important;
    background: #74788d !important;
    border-radius: 4px !important;
  }
}
</style>
